export default __webpack_public_path__ + "static/media/Ellipse-signup-bg.87423edd.svg";